import React from "react";
import { useApp } from "../../context/AppProvider";
import Modal from "./Modal";

const VideoModal = () => {
  const { videoModal, setVideoModal } = useApp();

  const handleClose = () => {
    setVideoModal(null);
  };

  // URL do vídeo embedado do YouTube
  const embedUrl = videoModal ? `https://www.youtube.com/embed/${videoModal}?autoplay=1&rel=0` : "";

  const isVisible = !!videoModal;

  return (
    <Modal 
      visibility={isVisible} 
      setVisibility={handleClose} 
      className="video-modal"
    >
      {videoModal && (
        <div className="video-modal-content">
          <div className="video-wrapper">
            <iframe
              width="100%"
              height="100%"
              src={embedUrl}
              title="Vídeo sobre doação"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default VideoModal;

